import EADialog from 'components/common/EADialog';
import i18next from 'i18next';
import { SecurityRatingLetterScoreEnum } from 'services/common/SecurityRatingUtils';
import useStyles from 'style/js-style/components/thirdparties/securityRating/SecurityRatingStyle';
import clsx from "clsx";

const SecurityRatingLetterScoresMeaningModal = ({ isOpen = false, onClose = () => { } }) => {
  const { classes } = useStyles();

  return (
    <EADialog
      isOpen={isOpen}
      maxWidth="md"
      hasActions={false}
      onClose={onClose}
      title={i18next.t("securityRating.letterScoresMeaningModal.title")}
    >

      {/* Score Letters Informations */}
      <div className={classes.scoreDetailModalWrapper}>
        {Object.values(SecurityRatingLetterScoreEnum).map(letterScore => (
          <div className={classes.letterScoreRow} key={letterScore}>
            <div className={clsx(classes.letterScoreSquare, `score-${letterScore}`)}>
              {letterScore}
            </div>
            <div className={classes.letterScoreText}>
              {i18next.t(`securityRating.letterScoresMeaningModal.letterScore.${letterScore}`)}
            </div>
          </div>
        ))}
      </div>

    </EADialog>
  )
};

export default SecurityRatingLetterScoresMeaningModal;